import {SpanIcon} from '@mazraeapp/react_icon_kit';

import Modal from '../../../../../components/mazraeKit/modal';

interface IModalProps {
  isSuccessModal: boolean;
  setIsSuccessModal: React.Dispatch<React.SetStateAction<boolean>>;
  removeOnClick?: () => void;
  understandOnClick?: () => void;
  type?: string;
}

const StoreAndLabShowPendingModal = ({
  setIsSuccessModal,
  isSuccessModal,
  removeOnClick,
  understandOnClick,
  type,
}: IModalProps) => {
  return (
    <Modal isOpen={isSuccessModal} setIsOpen={setIsSuccessModal}>
      <div className="w-[320px] flex flex-col p-3 gap-3">
        <div className="flex items-center justify-between">
          <div className="flex w-[90%] justify-center">
            <SpanIcon className="icon-size2486 text-[30px]  text-red-600" />
          </div>
          <button aria-label="بستن" onClick={removeOnClick}>
            <SpanIcon className="icon-nameClose-remove text-xl text-gray-700 w-[10%]" />
          </button>
        </div>
        <h5 className="w-full text-gray-950 flex justify-center">
          در انتظار تایید {type === 'lab' ? 'آزمایشگاه' : 'فروشگاه'}
        </h5>
        <p className="w-full p-0 m-0 text-gray-700 text-md font-Regular">
          {type === 'lab' ? 'آزمایشگاهی' : 'فروشگاهی'} که ثبت کرده‌اید در حال
          بررسی است. نتیجه بررسی به شما اعلام می‌شود.
        </p>

        <button
          className="border-red-600 text-red-600 rounded border-[1px] h-10 w-full mt-1 text-regular text-sm"
          onClick={understandOnClick}
        >
          بستن
        </button>
      </div>
    </Modal>
  );
};

export default StoreAndLabShowPendingModal;
